import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_ON_RESET_VEHICLE = `${VEHICLE_MODULE_PREFIX}_ON_RESET_VEHICLE`;
/**
 * This action will dispatch on click of vehicle reset link and when vehicle info changes
 * It will reset vehicle, vehicle attributes, vehicle equipment, vehicle acv, vehicle paint data
 * @returns IResetVehicleAction
 */
export const onResetVehicleAction = () => ({
    type: VEHICLE_ON_RESET_VEHICLE,
    payload: null
});
//# sourceMappingURL=resetVehicleAction.js.map